import React from "react";
import ApiServices from "../../../Utils/ApiServices/ApiServices";
import { getDecryptedAccessToken } from "../../../Utils/LoginUserDetails.js/LoginUserSavedDetails";
import RiteUserForm from "./RiteUserForm";

const RiteUserAdd = ({ onCreated }) => {
  const token = getDecryptedAccessToken();

  const handleSubmit = async (data, setSnackbar) => {
    try {
      await ApiServices.post("/api/v1/admin/users/create/", data, {
        Authorization: `Bearer ${token}`,
      });

      setSnackbar({
        open: true,
        severity: "success",
        message: "User created successfully",
      });

      onCreated();
    } catch (err) {
      setSnackbar({
        open: true,
        severity: "error",
        message: err?.response?.data?.email?.[0] || "Error creating user",
      });
    }
  };

  return <RiteUserForm title="Create User" onSubmit={handleSubmit} />;
};

export default RiteUserAdd;
